export const primaryNavigation = [
  { label: '首页', name: 'home' },
  { label: '产品体系', name: 'products' },
  { label: '聚星社区', name: 'community' },
  { label: '合作赋能', name: 'partnership' },
  { label: '关于我们', name: 'about' }
]

export default primaryNavigation
